import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FaBook } from "react-icons/fa";
import { UserContext } from "../../context/UserContext";
import { permissions } from "../../utils/permissions-utils";
import { useCases } from "./CasesContext";
import CaseCard from "./CaseCard";
import Pagination from "../../components/Pagination"; // Assuming a Pagination component exists
import { canUserEditCase } from "./medicalCasesUtils";
import "./CasesList.scss";

const CasesList = ({ handleAddNewCaseClick, isAnyFilterActive }) => {
	// Get updated context values
	const {
		cases, // Use 'cases' directly (API results for the current page)
		isLoading,
		error,
		requestDeleteCase, // Use the function that starts the delete process
		toggleFavorite,
		currentPage,
		totalPages,
		setCurrentPage,
		totalDocs,
	} = useCases();

	const navigate = useNavigate();
	const { user } = useContext(UserContext);

	// Navigation handlers remain similar, but use _id
	const handleViewCase = (id) => {
		navigate(`/cases/${id}/view`); // Corrected path to match Routes.jsx
	};

	const handleEditCase = (id) => {
		navigate(`/cases/${id}/edit`); // Corrected path to match Routes.jsx
	};

	// Delete handler now calls requestDeleteCase with the full case object
	const handleDeleteCase = (caseItem) => {
		requestDeleteCase(caseItem);
	};

	const canCreateMedicalCase = () => {
    	return permissions.canCreate(user);
  	};


	// Handle favorite toggle - pass the full case object
	const handleToggleFavorite = (caseItem) => {
		toggleFavorite(caseItem);
	};

	// if (loading) {
	// 	return <div className="loading-state">טוען מקרים...</div>;
	// }

	if (error) {
		return <div className="error-state">{error}</div>;
	}

	if (!isLoading && cases.length === 0 && !isAnyFilterActive) {
		return (
			<div style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				textAlign: 'center',
				minHeight: '50dvh'
			}}>
				<FaBook size={60} style={{ marginBottom: '20px', color: '#0C3058' }} />
				<p style={{
					fontSize: '1.5rem',
					maxWidth: '600px',
					marginBottom: '30px',
					direction: 'rtl'
				}}>
					{permissions.isWaitingForApproval(user) ?
						"ברגע שהצטרפותך למחלקה תאושר, בדף יהיה באפשרותך להעלות, לשמור ולתעד מקרים רפואיים מעניינים - אולטרסאונד, א.ק.ג, צילום CT או מקרה ששווה לדבר עליו בישיבת הבוקר הבאה." :
						"כאן באפשרותך להעלות, לשמור ולתעד מקרים רפואיים מעניינים - אולטרסאונד, א.ק.ג, צילום CT או מקרה ששווה לדבר עליו בישיבת הבוקר הבאה."
					}
				</p>
				{canCreateMedicalCase() && <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center', width: '100%', maxWidth: '300px' }}>
					<button
						onClick={handleAddNewCaseClick}
						style={{
							backgroundColor: 'white',
							color: '#0C3058',
							border: '1px solid #0C3058',
							padding: '10px 20px',
							borderRadius: '5px',
							cursor: 'pointer',
							boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
							fontWeight: 'bold',
							width: '100%'
						}}>
						<span className="mobile-only">העלאת צילום חדש</span>
						<span className="desktop-only">העלאת מקרה חדש</span>
					</button>
				</div>}
			</div>
		);
	}

	return (
		<>
			<div className="cases-grid">
				{/* Iterate over 'cases' from context */}
				{isLoading && [1, 2, 3].map((item) => <SkeletonCard key={item} />)}
				{!isLoading &&
					cases.map((case_) => (
						<CaseCard
							key={case_._id} // Use _id as key
							caseItem={case_}
							onView={() => handleViewCase(case_._id)} // Pass _id
							// Pass the full case object to delete/favorite handlers
							onEdit={canUserEditCase(user, case_) ? () => handleEditCase(case_._id) : null} // Pass _id
							onDelete={canUserEditCase(user, case_) ? () => handleDeleteCase(case_) : null}
							onToggleFavorite={() => handleToggleFavorite(case_)}
							showActions={canUserEditCase(user, case_)}
							isFavorite={user && case_.favoritedBy?.includes(user._id)} // Pass favorite status
						/>
					))}
			</div>

			{/* Add Pagination Controls */}
			{totalPages > 1 && (
				<Pagination
					currentPage={currentPage}
					totalPages={totalPages}
					onPageChange={(page) => setCurrentPage(page)}
				/>
			)}
			{/* Optional: Display total count */}
			{/* <div className="total-count">סה"כ: {totalDocs} מקרים</div> */}
		</>
	);
};

const SkeletonCard = () => {
	return (
		<div className="skeleton-card">
			<div className="skeleton-header">
				<div className="skeleton-icon" />
				<div className="skeleton-title" />
				<div className="skeleton-date" />
			</div>
			<div className="skeleton-tags">
				<div className="skeleton-tag" />
				<div className="skeleton-tag" />
			</div>
			<div className="skeleton-actions">
				<div className="skeleton-btn" />
				<div className="skeleton-btn" />
			</div>
		</div>
	);
};

export default CasesList;
